import React, { useState, useEffect } from "react";
import {Form } from 'react-bootstrap'
import { Link } from "gatsby";
import loadable from "@loadable/component"

import {CalculatorFields, rentalYieldResult} from "../../common/utils/mortgage"
import {addCommas, numericWithDecimal, numberFormat} from "../../common/utils/site_utlis"
import {currency} from "../../common/constant"
import {PageLinks} from "../../common/page-links"

const Select = loadable(() => import("react-select"));

const RentalYieldCalculator = () => {
    
    const options = [
        { value: 'Property Purchase Cost', label: 'Property Purchase Cost' },
        { value: 'Current Property Value', label: 'Current Property Value' },
    ]

    const [calculator_value, setCalculatorValue] = useState({'purchase_price': "1000000", "monthly_rent": '10000', "yearly_cost": ''});
    const[yieldResult, setYieldResult] = useState('');
    const[netyieldResult, setNetYieldResult] = useState('');
    const [error_msg, setErrorMsg] = useState('');

    const propertyValue = calculator_value.purchase_price;
    const monthly_rent = calculator_value.monthly_rent;
    const yearly_cost = calculator_value.yearly_cost;

    useEffect(()=>{
        //console.log("property_type", propertyValue,monthly_rent);
        //console.log("stampDuty", stampDuty);
        let annual_rent = monthly_rent * 12
        let rental_res = rentalYieldResult(propertyValue, annual_rent)
        setYieldResult(rental_res);

        if(yearly_cost){
            let annual_rent = yearly_cost
            let rental_res = rentalYieldResult(propertyValue, annual_rent)
            setNetYieldResult(rental_res);
        }

    },[propertyValue, monthly_rent, yearly_cost])


    const handleChange = (event, field_name) => {

        if(field_name === "monthly_rent"){
            if (parseFloat(numericWithDecimal(document.getElementById("monthly_rent").value)) > parseFloat(numericWithDecimal(document.getElementById("purchase_price").value))) {
                setErrorMsg("Monthly rent should not be greater than purchase price.")
            } else {
                setErrorMsg("");
                setCalculatorValue({...calculator_value, [event.target.name]: numericWithDecimal(event.target.value)})
            }
        }
        else if(field_name === "yearly_cost"){
            if (parseFloat(numericWithDecimal(document.getElementById("yearly_cost").value)) > parseFloat(numericWithDecimal(document.getElementById("purchase_price").value))) {
                setErrorMsg("Yearly cost should not be greater than purchase price.")
            } else {
                setErrorMsg("");
                setCalculatorValue({...calculator_value, [event.target.name]: numericWithDecimal(event.target.value)})
            }
        } else{
            setCalculatorValue({...calculator_value, [event.target.name]: numericWithDecimal(event.target.value)})
        }
    }

    const handleBlur = (event) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'calculator',
            'formType': "Rental Yield Calculator",
            'formName': "Rental Yield Calculator",
            'formLabel': "Rental Yield Calculator"
        });
    };

    let netyield_cost = yearly_cost ? parseFloat(yieldResult - netyieldResult).toFixed(2) : yieldResult

    //console.log("netyieldResult ==>", calculator_value, netyieldResult, yieldResult,  parseFloat(yieldResult - netyieldResult).toFixed(2))

    return (
        <React.Fragment>
            <div className="calculator-form">
                <Form action="javascript:;">
                    {error_msg && <div className="alert alert-danger col-12 p-3">{error_msg}</div>}

                    <Form.Group className="form-wrap">
                        <Form.Label>Rental Yield based on</Form.Label>
                        <Select options={options} name="yield_based" defaultValue={options[0]} placeholder={options[0].label} className="react-select form-control" classNamePrefix="react-select" onBlur={handleBlur} />
                    </Form.Group>

                    <Form.Group className="form-wrap">
                        <Form.Label>Purchase Price ({currency})</Form.Label>
                        <Form.Control type="text" name="purchase_price" id="purchase_price" value={addCommas(calculator_value.purchase_price)} onChange={handleChange} onBlur={handleBlur} maxLength={CalculatorFields.PriceInputMax}/>
                    </Form.Group>

                    <Form.Group className="form-wrap">
                        <Form.Label>Monthly Rent ({currency})</Form.Label>
                        <Form.Control type="text" name="monthly_rent" id="monthly_rent" onChange={(e) => handleChange(e, "monthly_rent")} onBlur={handleBlur} value={addCommas(calculator_value.monthly_rent)}/>
                    </Form.Group>

                    <Form.Group className="form-wrap">
                        <Form.Label>Yearly Running Cost ({currency})</Form.Label>
                        <Form.Control type="text" name="yearly_cost" id="yearly_cost" onChange={(e) => handleChange(e, "yearly_cost")} onBlur={handleBlur} value={addCommas(calculator_value.yearly_cost)} />
                    </Form.Group>
                </Form>

                <div className="calc-bottom">
                <div className="calc-res">
                        <span>Gross Rental Yield:</span>
                        <div className="final-res">{yieldResult}%</div>
                    </div>
                    <div className="calc-res">
                        <span>Net Rental Yield:</span>
                        <div className="final-res">{netyield_cost}%</div>
                    </div>
                    <Link to={`/${PageLinks.request_valuation}/`} className="btn btn-primary">Get a free valuation</Link>
                </div>
            </div>
        </React.Fragment>
    );
};
export default RentalYieldCalculator;
